export enum CovidHomeView {
    wachterNoWeeklyTesting = 'wachterNoEmployeeTesting',
    employeeNoWeeklyTesting = 'employeeNoWeeklyTesting',
    employeeWeeklyTesting = 'employeeWeeklyTesting'
}